var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardShortcut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      marginRight: 5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.833 3.542v9.916h11.333V3.542H2.833zm-.709-1.417h12.75a.708.708 0 0 1 .709.708v11.334a.708.708 0 0 1-.709.708H2.124a.708.708 0 0 1-.708-.708V2.833a.708.708 0 0 1 .708-.708zM4.25 4.958h1.417v1.417H4.249V4.958zm0 2.834h1.417v1.416H4.249V7.792zm0 2.833h8.5v1.417h-8.5v-1.417zm3.542-2.833h1.417v1.416H7.79V7.792zm0-2.834h1.417v1.417H7.79V4.958zm3.542 0h1.416v1.417h-1.416V4.958zm0 2.834h1.416v1.416h-1.416V7.792z",
    fill: "#67768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardShortcut);
export default __webpack_public_path__ + "static/media/KeyboardShortcut.6f8770723997db972ff2814961418152.svg";
export { ForwardRef as ReactComponent };